import React from "react";
import { useParams, Link } from "react-router-dom";
import "./TourPackageDetails.css";
import { tourPackagesData } from "../TourPackages/tourPackagesData";

const TourPackageDetails = () => {
  const { id } = useParams(); // slug
  const pkg = tourPackagesData[id];

  if (!pkg) {
    return (
      <h2 style={{ textAlign: "center", marginTop: "50px" }}>
        Package not found
      </h2>
    );
  }

  return (
    <div className="packageDetails">
      <div className="packageDetails-header">
        <img src={pkg.image} alt={pkg.title} />
        <div className="packageDetails-overlay">
          <h1>{pkg.title}</h1>
          <p>
            {pkg.duration} | <span className="price">{pkg.price}</span>
          </p>
        </div>
      </div>

      <div className="packageDetails-body">
        <h2>About this package</h2>
        <p>{pkg.description}</p>

        <h2>Itinerary</h2>
          <ul>
            {pkg.itinerary.map((item, i) => (
              <li key={`${pkg.slug}-itinerary-${i}`}>{item}</li>
            ))}
          </ul>
        <div className="packageDetails-columns">
          <div>
            <h2>Inclusions</h2>
            <ul>
              {pkg.inclusions.map((inc, i) => (
                <li key={`${pkg.slug}-inc-${i}`}>✅ {inc}</li>
              ))}
            </ul>
          </div>
          <div>
            <h2>Exclusions</h2>
            <ul>
              {pkg.exclusions.map((exc, i) => (
                <li key={`${pkg.slug}-exc-${i}`}>❌ {exc}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="packageDetails-actions">
          <button className="bookBtn">Book Now</button>
          <Link to="/tour-packages" className="backBtn">
            ← Back to Packages
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TourPackageDetails;
